import React, {createContext, useReducer} from 'react'
import {RouteFilterReducer} from "../reducers/RouteFilterReducer";

export const RouteFilterContext = createContext();

const RouteFilterContextProvider = (props) => {
    const state = {
        selectedRouteType: ["Core"],
        allRouteType: ["Core", "Non-Core"]
    }
    const [ viewModelRouteFilter, dispatchRouteFilter ] = useReducer(RouteFilterReducer, state);
    return (
        <RouteFilterContext.Provider value = {{viewModelRouteFilter, dispatchRouteFilter}}>
            {props.children}
        </RouteFilterContext.Provider>
    )
}

export default RouteFilterContextProvider


// WEBPACK FOOTER //
// ./src/components/routeView/context/RouteFilterContext.js